import React, { useMemo } from "react";
import SectionCard from "./SectionCard";
import { PhotoInput } from "./Fields";

export default function HeroImagesSection({ form, onChange, onOpenLibrary }) {
  const thumbs = useMemo(
    () =>
      [form.photoURL1, form.photoURL2, form.photoURL3]
        .map((url) => (typeof url === "string" ? url.trim() : ""))
        .filter(Boolean),
    [form.photoURL1, form.photoURL2, form.photoURL3]
  );

  return (
    <SectionCard
      title="Images d’accueil"
      description="Images utilisées dans la grande bannière de la page d’accueil."
    >
      <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
        <PhotoInput
          label="Photo 1"
          name="photoURL1"
          value={form.photoURL1}
          onChange={onChange}
          onOpenLibrary={() => onOpenLibrary("photoURL1")}
          showPreview={false}
        />

        <PhotoInput
          label="Photo 2"
          name="photoURL2"
          value={form.photoURL2}
          onChange={onChange}
          onOpenLibrary={() => onOpenLibrary("photoURL2")}
          showPreview={false}
        />

        <PhotoInput
          label="Photo 3"
          name="photoURL3"
          value={form.photoURL3}
          onChange={onChange}
          onOpenLibrary={() => onOpenLibrary("photoURL3")}
          showPreview={false}
        />
      </div>

      {thumbs.length ? (
        <div className="mt-5 grid grid-cols-1 gap-3 md:grid-cols-3">
          {thumbs.slice(0, 3).map((src, index) => (
            <div
              key={`${src}-${index}`}
              className="overflow-hidden rounded-3xl border border-slate-200 bg-slate-100 p-2 shadow-sm dark:border-slate-800 dark:bg-slate-950"
            >
              <div className="aspect-[16/7] w-full">
                <img
                  src={src}
                  alt={`Image d’accueil ${index + 1}`}
                  className="h-full w-full object-contain"
                  loading="lazy"
                />
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="mt-5 rounded-3xl border border-dashed border-slate-300 bg-slate-50 p-6 text-center text-sm text-slate-500 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-400">
          Aucune image d’accueil n’est encore renseignée.
        </div>
      )}
    </SectionCard>
  );
}